module.exports = __webpack_public_path__ + "img/Income-chart.402eaacf.png";